import { IAdyenCheckoutOrderInfoRequest, ICartPrice } from '@model';

import { IBaseAddress, ILastOrder } from '../../model';

/**
 * Method that is used to map last order data into adyen structure.
 * This method is used for checkout process of OaLT with adyen payment provider
 * @param orderData - last order data
 * @param orderId - new order id
 * @param cartPrice - cart price summary
 * @param cartId - users cart id
 * @param customerGuide - users customer guide
 */
export const mapOrderToAdyenOrder = (
  orderData: ILastOrder,
  orderId: number,
  cartPrice: ICartPrice,
  cartId: string,
  customerGuide?: string,
): IAdyenCheckoutOrderInfoRequest => ({
  orderId: orderId,
  cartId: cartId,
  amount: orderData.orderPricesSummary
    ? orderData.orderPricesSummary.totalPrice
    : cartPrice.priceItemSummary + cartPrice.pricePayment + cartPrice.priceDelivery,
  customer: {
    customerGuid: customerGuide ?? '',
    firstName: orderData.invoiceAddress.firstName,
    lastName: orderData.invoiceAddress.lastName,
    ...(checkForRequiredParams(orderData.invoiceAddress) && {
      billingAddress: {
        city: orderData.invoiceAddress.city,
        email: orderData.invoiceAddress.email,
        phone: orderData.invoiceAddress.phone,
        streetName: orderData.invoiceAddress.street,
        houseNumberOrName: orderData.invoiceAddress.streetNumber,
        stateProvince: orderData.invoiceAddress.province,
        zipCode: orderData.invoiceAddress.zipCode,
        countryCode: orderData.invoiceAddress.countryId,
      },
    }),
    ...(checkForRequiredParams(orderData.deliveryAddress) && {
      shippingAddress: {
        city: orderData.deliveryAddress.city,
        email: orderData.deliveryAddress.email,
        phone: orderData.deliveryAddress.phone,
        streetName: orderData.deliveryAddress.street,
        houseNumberOrName: orderData.deliveryAddress.streetNumber,
        stateProvince: orderData.deliveryAddress.province,
        zipCode: orderData.deliveryAddress.zipCode,
        countryCode: orderData.deliveryAddress.countryId,
      },
    }),
  },
});

/**
 * Method check whether the address contains all necessary info and returns TRUE is address can be used
 * @param contact - Delivery or Invoice address
 */
const checkForRequiredParams = (contact: IBaseAddress): boolean =>
  Boolean(contact.city) && Boolean(contact.street) && Boolean(contact.zipCode) && Boolean(contact.countryId);
